import { render, staticRenderFns } from "./SecurityUser.vue?vue&type=template&id=30fca00a&scoped=true&"
import script from "./SecurityUser.vue?vue&type=script&lang=js&"
export * from "./SecurityUser.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30fca00a",
  null
  
)

export default component.exports